import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import WhatsApp from './pages/WhatsApp';
import Pricing from './pages/Pricing';
import Settings from './pages/Settings';
import ForgotPassword from './pages/ForgotPassword';
import ContactList from './pages/ContactList';
import DeviceList from './pages/DeviceList';
import AppList from './pages/AppList';
import ManagePlans from './pages/ManagePlans';
import Checkout from './pages/Checkout';
import PaymentSuccess from './pages/PaymentSuccess';
import Reports from './pages/Reports';
import Sandbox from './pages/Sandbox';
import Docs from './pages/Docs';
import AdminUserReports from './pages/AdminUsers';
import SubscriptionReport from './pages/SubscriptionReport';
import AdminDashboard from './pages/AdminDashboard';
import Emailverified from './pages/Emailverified';
import ResetPassword from './pages/ResetPassword';
import Integrations from './pages/Integrations';
import Home from './website/Home';
import Privacy from './website/Privacy';
import Terms from './website/Terms';
import Refund from './website/Refund';
import ContactSupport from './website/ContactSupport';
import Contact from './website/ContactSupport';
import SupportList from './pages/SupportList';
import Mandate from './website/Mandate';
import SubscriptionRequests from './pages/SubscriptionRequests';
function App() {

  // A more robust Admin Guard
  const AdminRoute = ({ children }) => {
    const user = JSON.parse(localStorage.getItem('userData'))?.data;

    if (!user) return <Navigate to="/login" />;
    if (user.role !== 'admin') return <Navigate to="/dashboard" />;

    return children;
  };


  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>

          {/* Default route */}
     
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/refund" element={<Refund />} />
          <Route path="/support" element={<Contact />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/mandate" element={<Mandate />} />

          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/emailverified" element={<Emailverified />} />
          <Route path="/resetpassword" element={<ResetPassword />} />



          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/contacts" element={<ProtectedRoute><ContactList /></ProtectedRoute>} />
          <Route path="/whatsapp" element={<ProtectedRoute><WhatsApp /></ProtectedRoute>} />
          <Route path="/apps" element={<ProtectedRoute><AppList /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
          <Route path="/devices" element={<ProtectedRoute><DeviceList /></ProtectedRoute>} />
          <Route path="/plans" element={<ProtectedRoute><ManagePlans /></ProtectedRoute>} />
          <Route path="/pricing" element={<ProtectedRoute><Pricing /></ProtectedRoute>} />
          <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
          <Route path="/sandbox" element={<ProtectedRoute><Sandbox /></ProtectedRoute>} />
          <Route path="/docs" element={<ProtectedRoute><Docs /></ProtectedRoute>} />

          <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
          <Route path="/payment-success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
          <Route path="/integration" element={<ProtectedRoute><Integrations /></ProtectedRoute>} />
          <Route path="/supportlist" element={<ProtectedRoute><SupportList /></ProtectedRoute>} />


          {/* ADMIN SECTION */}
          {/* <Route
            path="/admin/users"
            element={
              <AdminRoute>
                <ProtectedRoute>
                  <AdminUserReports></AdminUserReports>
                </ProtectedRoute>
              </AdminRoute>
            }
          />
          <Route
            path="/admin/stats"
            element={
              <AdminRoute>
                <ProtectedRoute>
                  <SubscriptionReport></SubscriptionReport>
                </ProtectedRoute>
              </AdminRoute>
            }
          />
           <Route
            path="/admin/dashboard"
            element={
              <AdminRoute>
                <ProtectedRoute>
                  <AdminDashboard></AdminDashboard>
                </ProtectedRoute>
              </AdminRoute>
            }
          /> */}



<Route
  path="/admin/users"
  element={
    <ProtectedRoute role="admin">
      <AdminUserReports />
    </ProtectedRoute>
  }
/>

<Route
  path="/admin/stats"
  element={
    <ProtectedRoute role="admin">
      <SubscriptionReport />
    </ProtectedRoute>
  }
/>

<Route
  path="/admin/dashboard"
  element={
    <ProtectedRoute role="admin">
      <AdminDashboard />
    </ProtectedRoute>
  }
/>

<Route
  path="/admin/susbcriptions"
  element={
    <ProtectedRoute role="admin">
      <SubscriptionRequests />
    </ProtectedRoute>
  }
/>

        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
